import { Container } from "@mui/material";
import { FC } from "react";
import { Outlet } from "react-router-dom";
import { useUserContext } from "../../providers/userProvider";
import VerificationBanner from "../../components/common/ReminderBanner/ReminderBanner";

// Define the PrivateRoute functional component
export const PrivateRoute: FC = () => {
  const { isVerified } = useUserContext();

  return (
    <Container
      maxWidth={false}
      style={{
        padding: 0,
        margin: 0,
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: "100vh",
      }}
    >
      {/* Display the verification banner if the user is not verified */}
      {!isVerified && <VerificationBanner />}
      {/* Render the child routes */}
      <Outlet />
    </Container>
  );
};

export default PrivateRoute;
